module.exports = __webpack_public_path__ + "img/immeuble.c2719fd6.png";